

<main [@viewTypeRouteTransitionTrigger]="prepareRoute(outlet)" >
  <router-outlet #outlet="outlet"></router-outlet>
</main>


